import React from "react";
import AssetCategoryPage from "./AssetCategoryPage";

const MachineryAssets = () => {
  return <AssetCategoryPage category="Machinery" title="Machinery" />;
};

export default MachineryAssets;
